import { observable } from 'mobx';
import { createContext } from 'react';

const PersonalStore = observable({
  name: '',
  email: '',
  phone: '',
  country: '',
  civilStatus: 'single',
  haveDependent: false,
  dependentAmount: '',
  profession: 'businessman',
  valFullName: {
    error: false,
    message: '',
  },
  valEmail: {
    error: false,
    message: '',
  },
});

PersonalStore.setValue = function(name, value) {
  this[name] = value;
};

const PersonalStoreContext = createContext(PersonalStore);

export default PersonalStoreContext;
